module.exports = __webpack_public_path__ + "static/portfolio-7-dfce99d45661fb94195ea6af7e396b94.jpg";